// ./utils/groupSalesThreeLevels.js

const groupSalesThreeLevels = (data) => {
    if (!Array.isArray(data) || data.length === 0) {
        return [];
    }

    // 1. Group data into a nested object structure
    const grouped = data.reduce((acc, currentItem) => {
        // Ensure keys are trimmed for reliable grouping
        const deptNo = currentItem.DEPTNO ? currentItem.DEPTNO.trim() : 'Unspecified Department';
        const type = currentItem.TYPE ? currentItem.TYPE.trim() : 'Unspecified Type';
        const cashCred = currentItem.CASHCRED ? currentItem.CASHCRED.trim() : 'Unspecified CashCred';
        const amount = currentItem.AMOUNT || 0;
        const amountExclVAT = Number(currentItem.AMOUNT_EXCLVAT || 0);

        // Level 1: Group by DEPTNO
        if (!acc[deptNo]) {
            acc[deptNo] = {
                DEPTNO: deptNo,
                totalAmount: 0,
                totalAmountExclVAT: 0,
                types: {} 
            };
        }
        const deptGroup = acc[deptNo];
        deptGroup.totalAmount += amount;
        deptGroup.totalAmountExclVAT += amountExclVAT;

        // Level 2: Group by TYPE inside DEPTNO
        if (!deptGroup.types[type]) {
            deptGroup.types[type] = {
                DEPTNO: deptNo,
                TYPE: type,
                totalAmount: 0,
                totalAmountExclVAT: 0,
                cashCreds: {} 
            };
        }
        const typeGroup = deptGroup.types[type];
        typeGroup.totalAmount += amount;
        typeGroup.totalAmountExclVAT += amountExclVAT;

        // Level 3: Group by CASHCRED inside TYPE
        if (!typeGroup.cashCreds[cashCred]) {
            typeGroup.cashCreds[cashCred] = {
                DEPTNO: deptNo,
                TYPE: type,
                CASHCRED: cashCred,
                totalAmount: 0,
                totalAmountExclVAT: 0,
                items: [] 
            };
        }
        const cashCredGroup = typeGroup.cashCreds[cashCred];
        cashCredGroup.totalAmount += amount;
        cashCredGroup.totalAmountExclVAT += amountExclVAT;
        
        // 🔑 Detail Row Inclusion: Pushing the full raw data object (currentItem)
        // This ensures the SALESPERSON key is retained for detail rows.
        cashCredGroup.items.push(currentItem);

        return acc;
    }, {});

    // 2. Flatten the nested structure into a single array for table rendering
    const flattenedData = [];

    for (const deptNo in grouped) {
        const deptGroup = grouped[deptNo];
        
        // Add Level 1 Header: Department Total
        flattenedData.push({
            DEPTNO: deptGroup.DEPTNO,
            totalAmount: deptGroup.totalAmount,
            totalAmountExclVAT: deptGroup.totalAmountExclVAT,
            isGroupHeader: true,
        });

        for (const type in deptGroup.types) {
            const typeGroup = deptGroup.types[type];

            // Add Level 2 Header: Type Sub-Total
            flattenedData.push({
                DEPTNO: typeGroup.DEPTNO,
                TYPE: typeGroup.TYPE,
                totalAmount: typeGroup.totalAmount,
                totalAmountExclVAT: typeGroup.totalAmountExclVAT,
                isSubHeader: true,
            });

            for (const cashCred in typeGroup.cashCreds) {
                const cashCredGroup = typeGroup.cashCreds[cashCred];

                // Add Level 3 Header: CashCred Sub-Sub-Total
                flattenedData.push({
                    DEPTNO: cashCredGroup.DEPTNO,
                    TYPE: cashCredGroup.TYPE,
                    CASHCRED: cashCredGroup.CASHCRED,
                    totalAmount: cashCredGroup.totalAmount,
                    totalAmountExclVAT: typeGroup.totalAmountExclVAT,
                    isSubSubHeader: true,
                });

                // Add all transaction items (Detail Rows)
                flattenedData.push(...cashCredGroup.items);
            }
        }
    }

    return flattenedData;
};

export default groupSalesThreeLevels;